/** @format */

import { createSlice } from "@reduxjs/toolkit";

//start state value
const initialState = {
  value: {
    data: {},
    render: false,
    //handle id for delete and edit
    id: null,
    edit: false,

    spinner: false,
    // route => Services stats
    newService: false,
    newSection: false,
    childNewService: false,
    // route =>  expense
    newExpense: false,
    detailsExpense: false,
    // route =>  expense
    newAirport: false,
    detailsAirports: false,
    // route => manager
    newMangers: false,
    deleteServiceSecton: false,
    // order status
    orderStatus: false,
    //show delete Model
    deleteModel: false,

    overLay: false,
    isMenuOpen: false,
  },
};

const stateSlice = createSlice({
  name: "toggleState",
  initialState,
  reducers: {
    // add & hide Service
    showService(state, actions) {
      state.value.newService = true;
      state.value.overLay = true;
    },
    hideService(state, actions) {
      state.value.newService = false;
      state.value.overLay = false;
    },
    // add & hide an airports
    addAirport(state, actions) {
      state.value.newAirport = actions.payload;
      state.value.overLay = true;
    },

    hideAirport(state, actions) {
      state.value.newAirport = false;
      state.value.overLay = false;
    },
    // add & hide child Service
    showChildService(state, actions) {
      state.value.childNewService = true;
      state.value.overLay = true;
    },
    hideChildService(state, actions) {
      state.value.childNewService = false;
      state.value.overLay = false;
    },
    // add & Section Service
    showSectionService(state, action) {
      state.value.newSection = true;
      state.value.overLay = true;
    },
    hideSectionService(state, payload) {
      state.value.newSection = false;
      state.value.overLay = false;
      state.value.id = null;
    },

    // add & hide an expense
    addExpense(state, actions) {
      state.value.newExpense = true;
      state.value.overLay = true;
      state.value.id = true;
    },

    hideExpense(state, actions) {
      state.value.newExpense = false;
      state.value.overLay = false;
    },

    // show details expense
    showExpenseDetails(state, actions) {
      state.value.detailsExpense = true;
      state.value.overLay = true;
    },

    hideExpenseDetails(state, actions) {
      state.value.detailsExpense = false;
      state.value.overLay = false;
    },
    // add & hide an Manger
    addManger(state, actions) {
      state.value.newMangers = true;
      state.value.overLay = true;
    },

    hideManger(state, actions) {
      state.value.newMangers = false;
      state.value.overLay = false;
    },

    showDeleteServiceSecton(state, actions) {
      state.value.deleteServiceSecton = true;
      state.value.overLay = true;
    },
    hideDeleteServiceSecton(state, actions) {
      state.value.deleteServiceSecton = false;
      state.value.overLay = false;
    },
    // orders status
    showOrdersStatus(state, action) {
      state.value.orderStatus = true;
      state.value.overLay = true;
    },
    hideOrdersStatus(state, action) {
      state.value.orderStatus = false;
      state.value.overLay = false;
    },
    showDeleteModal(state, action) {
      state.value.deleteModel = true;
      state.value.overLay = true;
    },
    hideDeleteModal(state, action) {
      state.value.deleteModel = false;
      state.value.overLay = false;
      // state.value.id = null;
    },

    //handle spinner
    showLoader(state, payload) {
      state.value.spinner = true;
    },
    hideLoader(state, payload) {
      state.value.spinner = false;
    },
    // handle render
    toggleRender(state, payload) {
      state.value.render = !state.value.render;
    },
    //set id
    setId(state, action) {
      state.value.id = action.payload.id;
    },
    // handle edit
    ToggleEdit(state, action) {
      state.value.edit = !state.value.edit;
    },
    toggelSideMenu(state, action) {
      state.value.isMenuOpen = !state.value.isMenuOpen;
    },
  },
});

export const {
  showService,
  hideService,
  showChildService,
  hideChildService,
  showSectionService,
  hideSectionService,
  showDeleteServiceSecton,
  hideDeleteServiceSecton,
  addExpense,
  hideExpense,
  addAirport,
  hideAirport,
  showExpenseDetails,
  hideExpenseDetails,
  addManger,
  hideManger,
  setId,
  showOrdersStatus,
  hideOrdersStatus,
  showLoader,
  hideLoader,
  showDeleteModal,
  hideDeleteModal,
  toggleRender,
  ToggleEdit,
  toggelSideMenu,
} = stateSlice.actions;

export default stateSlice.reducer;
